import React from 'react';
import type { JsonLandingPage } from '@sy/ssr-types';
import BlogsBlock from '~/templates/LandingV2/components/BlogsBlock';
import SignupEmailPage from '~/scenes/Signup/scenes/SignupEmailPage';
import { CTARow } from '~/components/Marketing';
import { Translation } from '~/components/Translation';
import HeroSection from '../components/HeroSection';
import StreamYardVsCompetitorLogos from './components/StreamYardVsCompetitorLogos';
import MainImage from './components/MainImage';
import ComparisonHeader from './components/ComparisonHeader';
import ComparisonColumns from './components/ComparisonColumns';
import TableComparison from './components/TableComparison';

interface StreamYardVsCompetitorTemplateProps {
	data: Extract<JsonLandingPage, { template: 'competitor-comparison' }>;
}

const StreamYardVsCompetitorTemplate: React.FC<
	StreamYardVsCompetitorTemplateProps
> = ({ data }) => {
	const { content } = data;
	const { competitor, fullCompetitorName } = content;

	return (
		<div className="streamyard-vs-competitor-landing-page">
			{content.hero && (
				<HeroSection
					titleKey={content.hero.titleKey}
					subtitleKey={content.hero.subtitleKey}
					heroImage={<StreamYardVsCompetitorLogos competitor={competitor} />}
				/>
			)}
			{content.mainImage?.type && (
				<MainImage
					competitor={competitor}
					competitorName={fullCompetitorName || competitor}
					imageType={content.mainImage.type}
				/>
			)}
			{content.comparisonHeader && (
				<ComparisonHeader
					titleKey={content.comparisonHeader.titleKey}
					subtitleKey={content.comparisonHeader.subtitleKey}
				/>
			)}
			{content.comparisonColumns && (
				<ComparisonColumns
					competitor={competitor}
					fullCompetitorName={fullCompetitorName}
					features={content.comparisonColumns.features}
				/>
			)}
			{content.tableComparison && (
				<TableComparison
					competitor={competitor}
					fullCompetitorName={fullCompetitorName}
					titleKey={content.tableComparison.titleKey}
					subtitleKey={content.tableComparison.subtitleKey}
					features={content.tableComparison.features}
				/>
			)}
			<BlogsBlock />
			<CTARow
				title={<Translation tid="landingMainPage.cta.title" />}
				subtitle={<Translation tid="landingMainPage.cta.body" />}
				cta={<SignupEmailPage isLandingPage isCustomLanding />}
			/>
		</div>
	);
};

export default StreamYardVsCompetitorTemplate;
